import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { CustomerJobService } from '../customerjobs.service';
import { CustomerJob } from '../customerjobs';
import { Observable, empty } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { faEdit, faBan, faCopy } from '@fortawesome/free-solid-svg-icons';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { Customer } from '../customers';
import { GridDeleteComponent } from '../../utils/grid-delete-component';
import { AuthService } from '../../auth.service';
import { LoggingService } from '../../utils/logging.service';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { io } from 'socket.io-client';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatAutocomplete, MatChipInputEvent } from '@angular/material';
import { LocationService } from 'src/app/location/location.service';
import { SubdivisionService } from 'src/app/subdivisions/subdivision.service';
import { JobTypeService } from 'src/app/jobs/jobtypes.service';
import { TagService } from 'src/app/utils/tags.service';

@Component({
  selector: 'app-edit-jobtype',
  templateUrl: './edit-customer-jobs-dialog.html',
  styleUrls: ['./customer-jobs.component.css']
})

export class EditCustomerJobDialogComponent implements OnInit {
  showRe: boolean = false;
  reInfo: any;
  tags: any[] = [];
  inputTags: any[] = [];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredTags: Observable<any[]>;
  inheritedTagsSubdivision: boolean = false;
  subdivision$: Observable<any[]>;
  subdivisionDisplay: string;
  site_visit_required: boolean = false;

  // MF / SF / GPS tag-type filter. Empty = show all.
  tagTypeFilter: string[] = [];
  get visibleTags(): any[] { return this.tagService.filterByTypes(this.tags, this.tagTypeFilter); }
  toggleTagType(t: string): void {
    this.tagService.toggleType(this.tagTypeFilter, t);
    const c = this.form.get('tagControl');
    if (c && c.value) { c.setValue(c.value); }
  }

  constructor(public dialogRef: MatDialogRef<EditCustomerJobDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: CustomerJob, private jtservices: JobTypeService, private locservice: LocationService, private fb:FormBuilder, public service: CustomerJobService, private messager: MessagerComponent, private subdivisionService: SubdivisionService, public tagService: TagService, private log: LoggingService) {}

  form = new FormGroup({

    customerjob_id : new FormControl(this.data.customerjob_id || ''),
    customer : new FormControl(this.data.customer || ''),
    job_type : new FormControl(this.data.job_type || ''),
    price : new FormControl(this.data.price || ''),
    note : new FormControl(this.data.note || ''),
    inactivecustomerjob : new FormControl(this.data.inactivecustomerjob || false),
    customer_name : new FormControl(this.data.customer_name || ''),
    job_type_name : new FormControl(this.data.job_type_name || ''),
    rate : new FormControl(this.data.rate?.trim() || ''),
    flatadder : new FormControl(this.data.flatadder || ''),
    alias : new FormControl(this.data.alias || ''),
    ratercompid : new FormControl(this.data.ratercompid || ''),
    estimatedtime : new FormControl(this.data.estimatedtime || ''),
    required : new FormControl(this.data.required || ''),
    repemaildist : new FormControl(this.data.repemaildist || ''),
    qirepfrom : new FormControl(this.data.qirepfrom || ''),
    invoicetobeemailed : new FormControl(this.data.invoicetobeemailed || false),
    invoicetobeprinted: new FormControl(this.data.invoicetobeprinted || false),
    billable: new FormControl(this.data.billable !== undefined ? this.data.billable : true),
    createRe: new FormControl(false),
    envspecs: new FormControl(this.data.envspecs || ""),
    testspecs : new FormControl(this.data.testspecs || ""),
    stickerplacement: new FormControl(this.data.stickerplacement || ""),
    hvacspecs: new FormControl(this.data.hvacspecs || ""),
    billingnote : new FormControl(this.data.billingnote || ""),
    subdivision : new FormControl(this.data.subdivision || ''),
    tagControl: new FormControl()
  });


  createRe: boolean = false;

  @ViewChild('custname', {read: false, static: false})
  custNameInputRef: ElementRef;

  @ViewChild('jtname', {read: false, static: false})
  jtNameInputRef: ElementRef;

  @ViewChild('jtAlias', {read: false, static: false})
  jtAlias: ElementRef;

  mode = this.data.mode;
  showtext = '';
  isDuplicate = false;
  isLoading = false;
  customer$ : Observable<Customer[]>;
  jobtype$ : Observable<any[]>;


  rates = [
    {value: 'PerSqFt', viewValue: 'PerSqFt'},
    {value: 'Per HVAC System', viewValue: 'Per HVAC System'},
    {value: 'Flat Price', viewValue: 'Flat Price'},
    {value: 'Per Hour', viewValue: 'Per Hour'},
    {value: 'Per Addnl System', viewValue: 'Per Addnl System'},
    {value: 'Other', viewValue: 'Other (Specify in notes)'}
  ];

  ngOnInit() {

    //get tags
    this.locservice.getTags().subscribe(
      res => {
        this.tags = res.data;
      });

      this.data.cjtags?.forEach(tag => {
        this.locservice.getTag(tag).subscribe(
          res => {
            this.inputTags.push(res.data);
          }
        );
      });

      this.subdivisionService.getOneSubdivision(this.data.subdivision).subscribe(
        res => {
          this.subdivisionDisplay = res.Subdivision.subdivision_name;
        }
      );



    //pre-fill dropdowns here
    this.customer$ = this.form.get('customer_name').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.service.getCustomersDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );

    this.subdivision$ = this.form.get('subdivision').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.locservice.getSubdivisionsDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );

    this.jobtype$ = this.form.get('job_type_name').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.service.getJobTypes(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );

    this.filteredTags = this.form.get('tagControl').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
      }),
      filter((tag: string | null) => tag && tag.length > 0),
      map((tag: string | null) => tag ? this._filter(tag) : this.tags.slice())
    );

  }

  displayFunction(customer: Customer){
    if (customer) { return customer.customer_name; }
  }

  addTag(event: MatChipInputEvent, tag?: any): void {

    const input = event.input;
    // Only add tag if it is not already selected
    if(tag){
      if (this.inputTags) {
        const tagIds = this.inputTags.map(existingTag => existingTag.id);
        if (!tagIds.includes(tag.id)) {
          this.inputTags.push(tag);
          this.log.info(this.data.loggedIn + ' added tag#' + tag.id + ' (named: ' + tag.displayname + ') to the ' + this.form.get('customer_name') + '-' + this.form.get('job_type_name') );
        }
      }
    }
    input.value = '';
    //this.processTags();

  }

  removeTag(tag: any): void {
    const index = this.inputTags.indexOf(tag);

    if (index >= 0) {
      this.inputTags.splice(index, 1);
      this.log.info(this.data.loggedIn + ' added tag#' + tag.id + ' (named: ' + tag.displayname + ') to the ' + this.form.get('customer_name') + '-' + this.form.get('job_type_name') );
    }
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.visibleTags.filter(tag => tag.displayname.toLowerCase().includes(filterValue));
  }


  onEnter(auto: MatAutocomplete): void {
      this.form.get('tagControl').setValue('');

  }

  clearOut(field: string){ 
    this.form.get('subdivision').setValue('');
    if(field.includes('subdivision')){
      this.subdivisionDisplay = '';
    };
  }

  toggleCreateRe() {
    this.createRe = !this.createRe;
  }

  onSelectSubdivision(subdivision: any): void {
    this.data.subdivision = subdivision.subdivision_id;
    this.subdivisionDisplay = subdivision.subdivision_name || '(No Subdivision)';
    this.form.get('subdivision').setValue(subdivision.subdivision_id);
    this.checkForDuplicate();
  }

  onSelectCustomer(customer: Customer): void {
    this.data.customer = customer.customer_id;
    this.form.get('customer').setValue(customer.customer_id);
    this.data.customer_name = customer.customer_name;
    this.form.get('customer_name').setValue(customer.customer_name);
    this.custNameInputRef.nativeElement.value = customer.customer_name;

    if(this.form.get('job_type').value && this.data.mode == 2){
      this.checkForDuplicate();
    }

  }


  processTags(){

    //loop through all tags, grab the id and push to id array;
    let idArray = [];
    this.inputTags.forEach(element => idArray.push(element.id));

    //call API function to update tag use count:

    this.locservice.updateTagUseCount(idArray).subscribe(
      res => {
      });

  }

  checkEstimatedTime(): void {
    if(this.site_visit_required && (!this.form.get('estimatedtime').value || this.form.get('estimatedtime').value == 0)){
      document.getElementById('addbutton').classList.add('hiddenButton');
    }else{
      document.getElementById('addbutton').classList.remove('hiddenButton');
    }
  }

  onSelectJobType(object: any): void {
    this.data.job_type = object.job_type_id;
    this.form.get('job_type').setValue(object.job_type_id);
    this.data.job_type_name = object.job_type;
    this.form.get('job_type_name').setValue(object.job_type);
    this.jtNameInputRef.nativeElement.value = object.job_type;

    this.form.get('alias').setValue(object.dalias);
    this.jtAlias.nativeElement.value = object.dalias;

    this.jtservices.jobIsSiteVisitReqd(object.job_type_id).subscribe(
      res => {
        if(!res.Error){
          this.site_visit_required = res.siteVisitReqd;
        }

        if(this.site_visit_required && (!this.form.get('estimatedtime').value || this.form.get('estimatedtime').value == 0)){
          document.getElementById('addbutton').classList.add('hiddenButton');
        }

      });


    //check valid
    if(this.form.get('customer_name').value && this.data.mode == 2){
      this.checkForDuplicate();

      //see if this is eligible for a re-job

      this.service.getRe(object.job_type).subscribe(
        res => {
          if(!res.Error){
            this.showRe = true;
            this.reInfo = res;
          }
        })

    }

  }

  checkForDuplicate(): void {

    this.service.checkDuplicate(this.form.get('customer_name').value,this.form.get('job_type_name').value).subscribe(
      res => {
        if(res.Length > 0){
          if(this.form.get('subdivision').value > 0){
            this.showtext = 'This is a new customer job, as long as the subdivision remains defined.';
            this.isDuplicate = false;
          }else {
            this.showtext = 'This is a duplicate, please change either the customer, the jobtype or add a subdivision!';
            //this.isDuplicate = true;
            this.isDuplicate = false; // allow duplicates for now even without subdivision
          }
        } else {
          this.showtext = 'This is a new customer job.';
          this.isDuplicate = false;
        }
      },err => {

      }
    )


  }

  onNoClick(): void {
    this.dialogRef.close();
  }



  save(): void {


    const tagIds = this.inputTags.map(tag => tag.id);
    this.form.get('tagControl').setValue(tagIds);

    this.processTags();


    let changedProperties = [];
      Object.keys(this.form.controls).forEach((name) => {
            const currentControl = this.form.controls[name];

            if (currentControl.dirty) {
              changedProperties.push(name +': ' + this.form.controls[name].value);
            }
      });

      let job = this.form.value; 
      if(this.form.get('subdivision').value > 0){
        job.subdivision_name = this.subdivisionDisplay;
      }else{
        this.form.get('subdivision').setValue(null);
      }


    this.service.saveEdit(this.data.customerjob_id, job).subscribe(
      res => {

        if(res.Error){
          this.log.error(this.data.loggedIn + ' encountered an error editing a customer job: Submitted data: ' + '{' + this.form.value.toString() + '} ' + res.Message );
        }else {
        this.dialogRef.close();
        this.log.info(this.data.loggedIn + ' saved the following edits to customer job: ' + this.form.value.customer_name.trim() + '-' + this.form.value.job_type_name.trim() + ' {' + changedProperties.toString() + '}' );
        }
      },
      err => {
        this.log.error(this.data.loggedIn + ' encountered an error editing a customer job: Submitted data: ' + '{' + this.form.value.toString() + '} ' + err.toString() );
      }
    );

  }


  updateOtherQIs(): void {
    this.service.updateOtherQIs(this.form.get('customer').value, this.form.get('repemaildist').value).subscribe(
      res => {
        if(res.error){
          this.messager.openSnackBar('Error updating other QI jobs: ' + res.message, '', 'errorAlert');
          this.log.error('Error updating other QI jobs: ' + res.message);
        }else {
          this.messager.openSnackBar(res.message, '', 'successAlert');
          this.log.info('Updated other QI jobs for customer: ' + this.data.customer_name);
        }
      }, err => {
        this.messager.openSnackBar('Error updating other QI jobs: ' + err.toString(), '', 'errorAlert');
        this.log.error('Error updating other QI jobs: ' + err.toString());
      }
    );
  }

  customerInputHandler(){
    this.form.get('customer').setValue("");
  }

  jobInputHandler(){
    this.form.get('job_type').setValue("");
  }

    add(): void {

      const tagIds = this.inputTags.map(tag => tag.id);
      this.form.get('tagControl').setValue(tagIds);
      this.processTags();

      if(this.form.value.customer==""){
        this.form.get('customer_name').setValue("");
        this.data.customer_name = ''
        this.messager.openSnackBar("customer name is not valid.", "", "errorAlert");
      }
      if(this.form.value.job_type =="" ){
        this.form.get('job_type_name').setValue("");
        this.data.job_type_name = ''
        this.messager.openSnackBar("job name is not valid.", "", "errorAlert");
      }
      if(this.form.value.job_type =="" || this.form.value.customer==""){
        return
      }
      if(this.isDuplicate){
        this.messager.openSnackBar("There is already a customer job with this exact name, please change before saving.", "", "errorAlert");
      }else {

        let ogJob = this.form.value; 
        if(this.form.get('subdivision').value > 0){
          ogJob.subdivision_name = this.subdivisionDisplay;
        }else{
          this.form.get('subdivision').setValue(null);
        }

        
        //create OG customer job type
        this.service.add(ogJob).subscribe(
          res => {
            if(res.Error){
              this.log.error(this.data.loggedIn + ' encountered an error creating a customer job: Submitted data: ' + '{' + this.form.value.toString() + '} ' + res.Message );
            }else {

              //add the RE to the frontend
              let newData = res.CJ;
              this.service.addOneFrontend(newData);

              //check if there's to be a RE
              if(this.createRe){
                let newJob = {
                  ...this.form.value
                }

                newJob.job_type_name = this.reInfo.JobType.job_type;
                newJob.job_type = this.reInfo.JobType.job_type_id;
                newJob.price = '$150';
                if(this.form.get('subdivision').value > 0){
                  newJob.subdivision_name = this.subdivisionDisplay;
                }

                this.service.add(newJob).subscribe(
                  res => {
                    if(res.Error){
                      this.log.error(this.data.loggedIn + ' encountered an error creating a customer job: Submitted data: ' + '{' + newJob.toString() + '} ' + res.Message );
                    }else {
                      let newDataRe = res.CJ;
                      this.service.addOneFrontend(newDataRe);
                      this.log.info(this.data.loggedIn + ' created the customer job ' + newJob.customer_name.trim() + '-' + newJob.job_type_name.trim() );
                    }
                  }, err => {
                      this.log.error(this.data.loggedIn + ' encountered an error creating a customer job: Submitted data: ' + '{' + newJob.toString() + '} ' + err.toString() );

                  })
              }

              this.log.info(this.data.loggedIn + ' created the customer job ' + this.form.value.customer_name.trim() + '-' + this.form.value.job_type_name.trim() );
              this.dialogRef.close();
            }

            this.dialogRef.close(this.form.value);
          },
          err => {
            this.log.error(this.data.loggedIn + ' encountered an error creating a customer job: Submitted data: ' + '{' + this.form.value.toString() + '} ' + err.toString() );
          }
        );
      }

    }




}

@Component({
  selector: 'app-customer-jobs',
  templateUrl: './customer-jobs.component.html',
  styleUrls: ['./customer-jobs.component.css']
})
export class CustomerJobsComponent implements OnInit {

  public configuration: Config;
  public columns: Columns[];
  editData;

  user;
  usernamee;
  socket;

  modal = false;
  selected;

  faedit = faEdit;
  // Card 6TSzF61V: this button deactivates rather than deletes, so it wears a ban icon.
  fadeactivate = faBan;
  facopy = faCopy;
  activeJobToggle = false;
  filterActiveJob$: Observable<CustomerJob[]>;
  gridEntrie$: Observable<CustomerJob[]>;
  displayedColumns: string[] = ['customer_name', 'job_type_name', 'note'];

  constructor(public customerJobService: CustomerJobService, public dialog: MatDialog, public auth: AuthService, public log: LoggingService) {

    this.socket = io(this.customerJobService.getBaseURL());

  }

  ngOnInit(): void {

    this.customerJobService.init();


    this.configuration = {...DefaultConfig};
    this.configuration.tableLayout.theme = 'lIGHT';
    this.configuration.tableLayout.style = 'big';
    this.configuration.tableLayout.borderless = false;
    this.configuration.tableLayout.hover = true;
    this.configuration.searchEnabled = true;
    this.configuration.paginationEnabled = true;
    this.configuration.paginationRangeEnabled = false;
    this.configuration.isLoading = true;
    this.configuration.rows = 100;

    this.gridEntrie$ = this.customerJobService.getInitial().pipe(
      tap(() => {
        this.configuration.isLoading = this.customerJobService.isLoading;
      })
    );

    this.filterActiveJob$ = this.gridEntrie$;

    this.columns = [
      { key: '', title: '', searchEnabled: false},
      { key: 'customer_name', title: 'Customer Name' },
      { key: 'job_type_name', title: 'Job Type Name' },
      { key: 'note', title: 'Note' }
    ]

    this.auth.userProfile$.subscribe(
      (profile) => {


        this.user = profile;
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });


  }//ng On init

  filterActiveJobs(): void {
    this.activeJobToggle = !this.activeJobToggle;
    if (this.activeJobToggle) {
      this.filterActiveJob$ = this.gridEntrie$.pipe(
        map((jobs) => jobs.filter((job) => job.inactivecustomerjob === false))
      );
    } else {
      // Reset to the original list
      this.filterActiveJob$ = this.gridEntrie$;
    }
  }

  openDialog(myData): void {

    this.customerJobService.getOne(myData.customerjob_id).subscribe(
      (tdata: any) => {

        const dialogRef = this.dialog.open(EditCustomerJobDialogComponent, {
          width: '70vw',
          data: {
            customerjob_id : tdata.CustomerJob.customerjob_id,
            customer : tdata.CustomerJob.customer,
            job_type : tdata.CustomerJob.job_type,
            price : tdata.CustomerJob.price,
            note : tdata.CustomerJob.note,
            inactivecustomerjob : tdata.CustomerJob.inactivecustomerjob,
            customer_name : tdata.CustomerJob.customer_name,
            job_type_name : tdata.CustomerJob.job_type_name,
            rate : tdata.CustomerJob.rate?.trim(),
            flatadder : tdata.CustomerJob.flatadder,
            alias : tdata.CustomerJob.alias,
            ratercompid : tdata.CustomerJob.ratercompid,
            estimatedtime : tdata.CustomerJob.estimatedtime,
            repemaildist : tdata.CustomerJob.repemaildist,
            qirepfrom : tdata.CustomerJob.qirepfrom,
            invoicetobeprinted : tdata.CustomerJob.invoicetobeprinted,
            invoicetobeemailed: tdata.CustomerJob.invoicetobeemailed,
            billable: tdata.CustomerJob.billable,
            required: tdata.CustomerJob.required,
            envspecs: tdata.CustomerJob.envspecs,
            testspecs : tdata.CustomerJob.testspecs,
            hvacspecs: tdata.CustomerJob.hvacspecs,
            stickerplacement: tdata.CustomerJob.stickerplacement,
            mode: 1,
            loggedIn: this.usernamee,
            cjtags: tdata.CustomerJob.cjtags,
            billingnote : tdata.CustomerJob.billingnote,
            subdivision : tdata.CustomerJob.subdivision
          },
          panelClass: 'edit-dialog-container'
        });

        dialogRef.afterClosed().subscribe(result => {
          this.editData = result;
        });

      }
    )

  }

  delete(row): void {
    const dialogRef = this.dialog.open(GridDeleteComponent, {
      width: '500px',
      data: {
        delete_body_text: 'Are you sure you want to make this customer job inactive?',
        delete_api_url: '/rhAPI/customerjobs/delete/',
        delete_id: row.customerjob_id,
        delete_header_text: 'Deactivating ' + row.customer_name + '- ' + row.job_type_name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.customerJobService.deleteOne(row.customerjob_id);
        this.log.info(this.usernamee + ' marked the customer job inactive: ' + row.customer_name + '- ' + row.job_type_name + ' id: ' + row.customerjob_id);
      }
    });
  }

  copy(row): void {
    this.customerJobService.copy(row).subscribe(
      res => {
        this.customerJobService.addOneFrontend(res.CJ);
        this.log.info(this.usernamee + ' copied the customer job: ' + row.customer_name + '- ' + row.job_type_name + ' id: ' + row.customerjob_id);
      }, err => {
        this.log.error(this.usernamee + ' encountered an error copying the customer job: ' + row.customer_name + '- ' + row.job_type_name + ' id: ' + row.customerjob_id + ' ' + err.toString());
      }
    );
  }

  add(): void {
    const dialogRef = this.dialog.open(EditCustomerJobDialogComponent, {
      width: '70vw',
      data: {
        mode: 2,
        loggedIn: this.usernamee
      },
      panelClass: 'edit-dialog-container'
    });
  }

}
